import React, { Component } from 'react';
const logo = process.env.PUBLIC_URL + '/img/logo2.png';
import globalizacao from '../escolha/globalizacao';
import { posicionar } from '../modules/util';



class HomeIndex extends Component {
    onMore(e) {
        e.preventDefault();
        posicionar("tecnologia-utilizada");
    }

    render() {
        return (


            <section className="secao home-header">
                <div className=" logo-index ">
                    <div className="conteudo">
                        <img src={logo} />
                        <h1>
                            Escolha Tecnologia
                        </h1>
                        <h2>{globalizacao.msg("textoHome")}</h2>
                    </div>


                    <div className="btn-link-container">
                        <a className="btn-link" href="javascript:;" onClick={this.onMore} >
                            {globalizacao.msg("conhecaMais")} <br />
                            <i className="material-icons">&#xE313;</i>

                        </a>
                    </div>

                </div>

            </section>



        );
    }
}

export default HomeIndex;
